module.exports = __webpack_public_path__ + "static/assets/addd6b3a6dd680c6a39da59de1a039a9.png";